import React from 'react';
import { CommandBarProps } from './types';

const CommandBar: React.FC<CommandBarProps> = ({
  authUserName,
  welcomeMessage,
  stats,
  systemHealthData,
  demoModeEnabled,
  demoModeLoading,
  onToggleDemoMode,
  onOpenDemoModal,
  rateLimitDisabled,
  rateLimitLoading,
  onToggleRateLimit,
  activeTab,
  tabs,
  onTabChange,
}) => {
  return (
    <>
      {/* Greeting — above tabs */}
      <div className="mb-6 text-left">
        <h1 className="text-3xl font-bold text-slate-900 text-left">
          {(() => { const h = new Date().getHours(); return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening'; })()}, {authUserName}
        </h1>
        <p className="text-slate-500 mt-1 text-left">
          Stay on top of your compliance operations, monitor progress, and track platform status.
        </p>
      </div>

      {/* Pill Tab Navigation + Status Indicators */}
      <div className="flex justify-between items-center mb-8">
        {/* Tabs */}
        <div className="flex bg-white rounded-full p-1 shadow-sm border border-slate-200">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
                  isActive ? 'bg-slate-900 text-white' : 'text-slate-500 hover:text-slate-700'
                }`}
              >
                {tab.label}
                {tab.badge && (
                  <span className={`ml-1.5 px-1.5 rounded text-[10px] ${
                    isActive ? 'bg-white/20 text-white' : 'bg-slate-100 text-slate-500'
                  }`}>
                    {tab.badge}
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {/* Status dots + Demo FW */}
        <div className="flex items-center gap-4 text-xs font-semibold text-slate-500">
          <button
            onClick={onToggleDemoMode}
            disabled={demoModeLoading}
            className="flex items-center gap-1.5 hover:text-slate-700 transition-colors"
          >
            <span className={`w-2 h-2 rounded-full ${demoModeEnabled ? 'bg-green-500' : 'bg-slate-300'}`} />
            Demo {demoModeEnabled ? 'ON' : 'OFF'}
          </button>
          <button
            onClick={onToggleRateLimit}
            disabled={rateLimitLoading}
            className={`flex items-center gap-1.5 hover:text-slate-700 transition-colors ${rateLimitDisabled ? 'text-red-500' : ''}`}
          >
            <span className={`w-2 h-2 rounded-full ${rateLimitDisabled ? 'bg-red-500' : 'bg-green-500'}`} />
            Rate Limit {rateLimitDisabled ? 'OFF' : 'ON'}
          </button>
          <button
            onClick={onOpenDemoModal}
            className="flex items-center gap-1.5 text-blue-600 hover:text-blue-800 transition-colors"
          >
            <span className="w-2 h-2 rounded-full bg-blue-500" />
            Demo Framework
          </button>
        </div>
      </div>
    </>
  );
};

export default CommandBar;
